import jobManagerClient from '../services/http-client';
import { useModuleMutation } from '../../useModuleMutation';
import { jobModuleKeys } from './queries';

// DELETE /applications/{id}
export const useDeleteApplicationMutation = () =>
  useModuleMutation({
    fn: (id: string) => jobManagerClient.delete<void>(`applications/${id}`),
    // Invalidate the applications list so the table refreshes
    invalidate: (clientId) => [jobModuleKeys.applications(clientId)],
  });
